export class CostCenter {
    id: number;
    name: string;
    constructor(
    ) { }
}